import { Button } from '@domgen/base-design-system-2.0/atoms/Button';
import { ComboBox } from '@domgen/base-design-system-2.0/atoms/ComboBox';
import { Input } from '@domgen/base-design-system-2.0/atoms/Input';
import { TextLink } from '@domgen/base-design-system-2.0/atoms/TextLink';
import { AutoComplete } from '@domgen/shared/enums/autoComplete';
import { CircleCheck } from '../../../assets/icons/CircleCheck';
import type { ModelSerialLandingFormProps } from './ModelSerialLandingOnlineForm.types';

const styles = {
  root: 'flex flex-col gap-space-400',
  howToFindModel: 'text-center',
  ctaContainer: 'w-full pt-space-300',
};

export function ModelSerialLandingOnlineFormCallUs({
  modelNumber,
  serialNumber,
  errors,
  loading,
  modelOptions,
  waitForSearchError,
  onModelInputChange,
  onModelSelect,
  onSerialChange,
  onOpenModelHelp,
  onContinue,
  giftMessage,
}: ModelSerialLandingFormProps) {
  return (
    <div className={styles.root}>
      <section className="flex flex-col gap-space-400 desktop:flex-row desktop:gap-space-300">
        <ComboBox
          label="Model number"
          name="modelNumber"
          placeholder="For example MABC1234YZ"
          onInputChange={onModelInputChange}
          options={modelOptions}
          defaultValue={modelNumber}
          asyncProps={{ loading }}
          noResultsText="No appliances found"
          required
          onSelect={onModelSelect}
          hasSuccess={!!modelNumber && !errors.modelNumber}
          hasError={
            waitForSearchError && loading
              ? 'Please wait for the search to finish before continuing'
              : errors.modelNumber
          }
          allowCustomValue
          autoComplete={AutoComplete.OFF}
        />
        <Input
          placeholder="For example E61201983"
          value={serialNumber}
          label="Serial number"
          name="serialNumber"
          onChange={onSerialChange}
          hasSuccess={!!serialNumber && !errors.serialNumber}
          hasError={errors.serialNumber}
          rightIcon={serialNumber && !errors.serialNumber ? <CircleCheck /> : undefined}
          autoComplete={AutoComplete.OFF}
        />
      </section>
      {giftMessage}
      <div className={styles.howToFindModel}>
        <TextLink onClick={onOpenModelHelp}>How to find your model number</TextLink>
      </div>
      <div className={styles.ctaContainer}>
        <Button onClick={onContinue}>Continue</Button>
      </div>
    </div>
  );
}
